/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, DialogTitle, Box } from "@mui/material";

export const CrossIconContainer = styled('div')({
  display: 'flex', 
  justifyContent: 'flex-end', 
  margin: '10px 10px 0px 0px',
  cursor: 'pointer',
})

export const StyledDialogTitle = styled(DialogTitle)({
  '&.MuiDialogTitle-root': {
    padding: '0px 24px 12px 24px',
  },
  fontWeight: '600',
})

export const StatusContainer = styled(Box)(({ status }) => ({
  height: "24px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor:
    status === "success" ? "rgba(52, 199, 89, 0.1)" : "rgba(211, 47, 47, 0.1)",
  color: status === "success" ? "#2E7D32" : "#D32F2F",
}));

export const CountText = styled(DialogTitle)({
  paddingTop: '0px',
  fontSize: '14px',
  fontWeight: '400',
})

export const LoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '500px',
  width: '100%',
})
